import moment from 'moment/moment';
import {
  getDate,
  getStartOf,
  substract,
} from '../../../../../services/timeService';
import { unitOfTime } from '../../../../../services/timeService/types';

export interface Range {
  start: moment.Moment;
  end: moment.Moment;
}

export interface Preset {
  label: string;
  value: string;
  getRange?: () => Range;
}

export const PresetValue = {
  LAST_7: 'last7',
  LAST_30: 'last30',
  MTD: 'mtd',
  YTD: 'ytd',
  CUSTOM: 'custom',
} as const;
export type PresetValue = (typeof PresetValue)[keyof typeof PresetValue];

export const PRESETS: Record<PresetValue, Preset> = {
  last7: {
    label: 'Last 7 Days',
    value: 'last7',
    getRange: (): Range => {
      const start: moment.Moment = substract(unitOfTime.day, 7, getDate());
      const end: moment.Moment = getDate();
      return { start, end };
    },
  },
  last30: {
    label: 'Last 30 Days',
    value: 'last30',
    getRange: (): Range => {
      const start: moment.Moment = substract(unitOfTime.day, 30, getDate());
      const end: moment.Moment = getDate();
      return { start, end };
    },
  },
  mtd: {
    label: 'Month to Date',
    value: 'mtd',
    getRange: (): Range => {
      const start: moment.Moment = getStartOf(getDate(), unitOfTime.month);
      const end: moment.Moment = getDate();
      return { start, end };
    },
  },
  ytd: {
    label: 'Year to Date',
    value: 'ytd',
    getRange: (): Range => {
      const start: moment.Moment = getStartOf(getDate(), unitOfTime.year);
      const end: moment.Moment = getDate();
      return { start, end };
    },
  },
  custom: {
    label: 'Custom',
    value: 'custom',
  },
};
export const PRESETS_OPTIONS = Object.entries(PRESETS).map(([key, value]) => ({
  displayName: value.label,
  value: key,
}));

export const PRESETS_OPTIONS_MAP = new Map(
  Object.entries(PRESETS).map(([key, value]) => [key, value.label])
);
